<script setup lang="ts">
import { Button } from '@toruslabs/vue-components/Button';
import { Card } from '@toruslabs/vue-components/Card';
import { useAuthStore } from '../../store/authStore';
import { useClaimStore } from '../../store/claimStore';

// Assets
import NFT1 from '../../assets/claim/nft1.png';
import NFT2 from '../../assets/claim/nft2.png';
import NFT3 from '../../assets/claim/nft3.png';
import CodeIcon from '../../assets/claim/code.svg';
import IconBack from '../../assets/claim/icon-back.svg';
import { ref } from 'vue';

const claimStore = useClaimStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const inviteCode = ref('');
const invalidCode = ref(false);

function onCodeInput(event: Event) {
    invalidCode.value = false;
    const inputValue = (event.target as HTMLInputElement).value;
    inviteCode.value = inputValue;
}

async function onClaimCode() {
    if (!inviteCode.value) return;
    isLoading.value = true;
    const result = await claimStore.verifyInviteCode({ code: inviteCode.value });
    isLoading.value = false;
    if (!result) {
        invalidCode.value = true;
    }
}

async function logout() {
    await authStore.logout();
    claimStore.reset();
}
</script>

<template>
    <Button class="mb-2 !text-moca-gray-3 !text-sm !font-semibold !bg-moca-transparent !px-0" @on-click="logout">
        <img :src="IconBack" class="w-4" />
        <p>Back</p>
    </Button>
    <div class="flex flex-col justify-center items-center gap-6">
        <p class="text-white text-3xl font-bold">Claim <span class="text-moca-yellow">Moca ID</span></p>
        <p class="text-moca-white-80 text-lg font-medium">
            Sorry you can only claim Moca ID if you have a
            <span class="text-white font-bold">Moca NFT</span> or
            <span class="text-white font-bold">Invite Codes</span>
        </p>
        <div class="flex flex-row gap-2">
            <Card class="w-full tab:w-1/2"
                :classes="{ container: 'group-container !rounded-2xl !border-none tab:px-4 py-9 !bg-moca-card-id' }">
                <div class="flex flex-col justify-center items-center gap-6">
                    <div class="flex flex-col justify-center items-center gap-1">
                        <p class="text-white text-lg font-extrabold">I own a</p>
                        <p class="text-moca-yellow text-2xl font-extrabold">Moca NFT</p>
                        <p class="text-moca-white-80 text-base font-semibold text-center">
                            Own a Moca NFT(s) to claim Moca ID and get extra Moca holder benefits!
                        </p>
                    </div>
                    <div class="flex flex-row justify-center items-center mt-4">
                        <img :src="NFT1" class="w-[100px] h-[100px] border border-moca-white relative right-[-16px]" />
                        <img :src="NFT2" class="w-[100px] h-[100px] border border-moca-white relative top-[-16px]" />
                        <img :src="NFT3" class="w-[100px] h-[100px] border border-moca-white relative left-[-16px]" />
                    </div>
                    <p class="text-moca-green text-base font-semibold text-center">
                        *Your Moca must be staked for the entire previous weekly staking period
                    </p>
                    <Button
                        class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !rounded-full !px-6 min-w-[200px]"
                        @on-click="() => claimStore.chooseClaimMethod('nft')">
                        Claim with Mocas!
                    </Button>

                </div>
            </Card>
            <Card class="w-full tab:w-1/2"
                :classes="{ container: 'group-container !rounded-2xl !border-none tab:px-4 py-9 !bg-moca-card-id' }">
                <div class="flex flex-col justify-center items-center gap-6">
                    <div class="flex flex-col justify-center items-center gap-1">
                        <p class="text-white text-lg font-extrabold">Use My</p>
                        <p class="text-moca-yellow text-2xl font-extrabold">Invite Code</p>
                        <p class="text-moca-white-80 text-base font-semibold text-center">
                            Enter a Mocaverse distributed invite code to claim your own exclusive Moca ID!
                        </p>
                    </div>
                    <div class="flex flex-row justify-center items-center mt-1">
                        <img :src="CodeIcon" class="h-28" />
                    </div>
                    <form class="flex flex-col items-center justify-center w-full" @submit.prevent="onClaimCode">
                        <input :input="inviteCode" @input="event => onCodeInput(event)"
                            class="rounded-full border-2 border-black h-12 px-6 focus:border-moca-yellow focus-within:border-moca-yellow focus:outline-none w-full"
                            placeholder="Enter invite code" />
                        <p v-if="invalidCode" class="text-moca-error-red text-sm mt-1 w-full">*Invalid/ Used Invite Code</p>
                        <Button
                            class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !rounded-full !px-6 min-w-[200px] mt-6"
                            @on-click="() => onClaimCode()">
                            Claim with Code!
                        </Button>
                    </form>

                </div>
            </Card>
        </div>
    </div>
</template>
